import {CreateAbsenceFormValidationSchema} from '@/features/accesses/formSchemas'
import {zodResolver} from '@hookform/resolvers/zod'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const AbsenceFormProvider = ({
    children,
    defaultValues
}: {
    children: ReactNode
    defaultValues?: Partial<CreateAbsenceFormValidationSchema>
}) => {
    const form = useForm<CreateAbsenceFormValidationSchema>({
        resolver: zodResolver(CreateAbsenceFormValidationSchema),
        defaultValues: defaultValues
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
